import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import AuthServiceFactory from "@/services/authentication/AuthServiceFactory";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
let MyProfileView = class MyProfileView extends Vue {
    constructor() {
        super();
        this.authService = AuthServiceFactory.GetAuthService();
        this.isLoggedIn = false;
        this.user = null;
    }
    async mounted() {
        let isLoggedIn = await this.authService.isLoggedIn();
        if (isLoggedIn === true) {
            this.user = await this.authService.getUser();
        }
    }
    get loggedIn() {
        return this.isLoggedIn;
    }
    get firstName() {
        return this.user.profile.given_name;
    }
    get lastName() {
        return this.user.profile.family_name;
    }
    set lastName(value) {
        this.user.profile.family_name = value;
    }
    get lastNameErrors() {
        const errors = [];
        if (!this.$v.lastName.$dirty)
            return errors;
        !this.$v.lastName.maxLength &&
            errors.push("Last Name must be at most 30 characters long");
        !this.$v.lastName.required && errors.push("Last Name is required.");
        return errors;
    }
    get email() {
        return this.user.profile.sub;
    }
    set email(value) {
        this.user.profile.sub = value;
    }
    get emailErrors() {
        const errors = [];
        if (!this.$v.email.$dirty)
            return errors;
        !this.$v.email.email && errors.push("Must be valid e-mail");
        !this.$v.email.required && errors.push("E-mail is required");
        return errors;
    }
    async saveProfile() {
        console.log("Save profile clicked");
    }
};
MyProfileView = tslib_1.__decorate([
    Component({
        name: "MyProfile",
        components: {},
        mixins: [validationMixin],
        validations: {
            lastName: {
                required,
                maxLength: maxLength(10)
            },
            email: { required, email }
        }
    })
], MyProfileView);
export default MyProfileView;
